import script from "./poetryDetail.vue?vue&type=script&lang=ts&setup=true"
export * from "./poetryDetail.vue?vue&type=script&lang=ts&setup=true"

import "./poetryDetail.vue?vue&type=style&index=0&id=3a835ffe&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a835ffe"]])

export default __exports__